<template>
  <div
    class="h-screen w-screen flex items-center welcomeScreenBackground"
    @click.self="gotoLanding"
    aria-label="City Hall Kiosk - Tap to continue."
    :style="getImageStyle"
  >
    <div
      class="bg-white w-screen text-center"
      style="background-color:rgba(255, 255, 255, 0.8)"
      @click.self="gotoLanding"
    >
      <div class="inline-block">
        <div class="flex w-full mt-1">
          <div>
            <p ref="title" class="flex-grow welcomeHdr ml-5 text-dark-blue-500 text-6xl font-semibold text-left my-4">
              City Hall Kiosk
            </p>
          </div>
          <div class="pt-8 pl-2">
            <Button
              ref="enterButton"
              class="text-lg"
              label="ENTER"
              tabindex="0"
              v-on:btn-clicked="gotoLanding()"
              v-on:keyup.enter="gotoLanding()"
            />
          </div>
        </div>
        <hr class="pb-2" style="opacity: 0.2" />
        <p class="px-5 text-lg font-semibold pb-4" style="color:#333">
          Find city information, services and more.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router";
// @ is an alias to /src
import Button from "@/components/Button";

import backgroundWelcome_0 from "../assets/imgs/beach-welcome_0.jpg"
import backgroundWelcome_1 from "../assets/imgs/beach-welcome_1.jpg"
import backgroundWelcome_2 from "../assets/imgs/beach-welcome_2.jpg"
import backgroundWelcome_3 from "../assets/imgs/beach-welcome_3.jpg"
import backgroundWelcome_4 from "../assets/imgs/beach-welcome_4.jpg"
import backgroundWelcome_5 from "../assets/imgs/beach-welcome_5.jpg"
import backgroundWelcome_6 from "../assets/imgs/beach-welcome_6.jpg"
import backgroundWelcome_7 from "../assets/imgs/beach-welcome_7.jpg"
import backgroundWelcome_8 from "../assets/imgs/beach-welcome_8.jpg"
import backgroundWelcome_9 from "../assets/imgs/beach-welcome_9.jpg"
import backgroundWelcome_10 from "../assets/imgs/beach-welcome_10.jpg"
import backgroundWelcome_11 from "../assets/imgs/beach-welcome_11.jpg"

export default {
  name: "Home",
  components: { Button },
  /**
   * Data return
   * @return {[message: ""} [reset message]
   */
  data: function() {
    return {
      deviceInfo: undefined,
      message: "",
      backgroundImageFiles: [
        backgroundWelcome_0,
        backgroundWelcome_1,
        backgroundWelcome_2,
        backgroundWelcome_3,
        backgroundWelcome_4,
        backgroundWelcome_5,
        backgroundWelcome_6,
        backgroundWelcome_7,
        backgroundWelcome_8,
        backgroundWelcome_9,
        backgroundWelcome_10,
        backgroundWelcome_11,
      ]
    };
  },
  computed: {
    getImageStyle() {
      let fileNum = Math.floor(Math.random() * this.backgroundImageFiles.length);
      let fileSrc = this.backgroundImageFiles[fileNum];
      
      return `background-image: url("${fileSrc}");`;
    }
  },
  mounted() {
    this.$refs.enterButton.$el.focus()
  },
  methods: {
    gotoLanding() {
      router.push({ name: "News" });
    },
  },
};
</script>
